import { TextField, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSearchBar = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.colors.softGray,
  borderRadius: '10px',
  width: '100%',
  padding: '7px 8px',
  '& .MuiInputBase-root': {
    paddingLeft: '21px', // 15px search icon + 6px padding
  },
  '.MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
    '& input': {
      color: theme.colors.gray,
      padding: '0px',
      fontSize: '17px',
      fontWeight: '400',
      lineHeight: '22px',
      letterSpacing: '-0.408px',
    },
  },
  '.MuiInputAdornment-root': {
    position: 'absolute',
    left: '0px',
    margin: '0px',
    padding: '0px',
    height: '100%',
    color: theme.colors.gray,
    pointerEvents: 'none', // Make sure the icon doesn't interfere with input
    '& .MuiSvgIcon-root': {
      // Change icon default size
      width: '15px',
      height: '15px',
    },
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.colors.gray,
  padding: 0,
}));
